import type { Ref } from 'vue';
import type { RegionTag } from '@/shared/api/experience';
import { getUrl } from '@/entities/rubrics';
import { useI18n } from '@experience/i18n';
import ru from '@/widgets/rubricsBlock/i18n/ru.json';
import type { ContextType, ListingTagMap } from '@/entities/rubrics';

export function useTourRegionTagsAdapters(
  rubricsTags: Ref<RegionTag[]>,
  popupTags: Ref<RegionTag[]>,
  context: Ref<ContextType>,
) {
  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const rubricsAdapters = computed(() => {
    return rubricsTags.value.map((rubric) => ({
      value: rubric.slug,
      label: rubric.name || '',
      id: rubric?.id || undefined,
      counter: rubric?.counters?.[`${context.value}_count`] || 0,
      url: getUrl(rubric, context.value),
      is_tours_included: false,
    }));
  });

  const popupTagsAdapter = computed(() =>
    popupTags.value.map((tag) => ({
      ...tag,
      value: tag.slug,
      label: tag.name || '',
      id: tag?.id || 0,
      counter: tag?.counters?.[`${context.value}_count`] || 0,
      url: getUrl(tag, context.value),
      seoUrl: tag?.urls?.tours || '',
      href: '',
      is_tours_included: false,
    })),
  );

  const popupTagsMapped = computed(() => {
    const wrongCategories = new Set([t('rubrics_section.noCategory'), t('rubrics_section.noMentioned')]);
    const accMap = new Map<string, ListingTagMap>();

    return popupTagsAdapter.value.reduce<ListingTagMap[]>((acc, tag) => {
      const category = tag?.category;
      if (tag.counter === 0 || !category || wrongCategories.has(category)) {
        return acc;
      }

      let categoryObj = accMap.get(category);
      if (!categoryObj) {
        categoryObj = { title: category, tags: [] };
        acc.push(categoryObj);
        accMap.set(category, categoryObj);
      }

      categoryObj.tags.push(tag);

      return acc;
    }, []);
  });

  return { popupTagsMapped, rubricsAdapters };
}
